import { AccessPermissionRole } from "@core-services/data-types";
import { z } from "zod";
export const InviteUser = z.object({
    email: z.string().email(),
    role: z.nativeEnum(AccessPermissionRole),
    organizationPublicId: z.string(),
});
//# sourceMappingURL=user-invite.js.map